"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_TELEPEDAGGIO_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetTelepedaggio,
    skipImportingInCMS: false,
}, {
    tpdTelepedaggioApriSegnalazioneWidget: {
        __mfeName__: "tpdTelepedaggioApriSegnalazioneWidget",
        devClientPort: 6307,
        devServerPort: 6407,
    },
    tpdTelepedaggioAttivazioneMandatoSddWidget: {
        __mfeName__: "tpdTelepedaggioAttivazioneMandatoSddWidget",
        devClientPort: 6308,
        devServerPort: 6408,
    },
    tpdTelepedaggioDashboardWidget: {
        __mfeName__: "tpdTelepedaggioDashboardWidget",
        devClientPort: 6309,
        devServerPort: 6409,
    },
    tpdTelepedaggioLandingPageWidget: {
        __mfeName__: "tpdTelepedaggioLandingPageWidget",
        devClientPort: 6310,
        devServerPort: 6410,
    },
    tpdTelepedaggioModificaOffertaWidget: {
        __mfeName__: "tpdTelepedaggioModificaOffertaWidget",
        devClientPort: 6311,
        devServerPort: 6411,
    },
    tpdTelepedaggioPurchaseWidget: {
        __mfeName__: "tpdTelepedaggioPurchaseWidget",
        devClientPort: 6312,
        devServerPort: 6412,
    },
    tpdTelepedaggioWidgetHomepageWidget: {
        __mfeName__: "tpdTelepedaggioWidgetHomepageWidget",
        devClientPort: 6314,
        devServerPort: 6414,
    },
    tpdTelepedaggioWidgetPolizzeCollettiveWidget: {
        __mfeName__: "tpdTelepedaggioWidgetPolizzeCollettiveWidget",
        devClientPort: 6315,
        devServerPort: 6415,
    },
    tpdTelepedaggioAreaRiservataWidget: {
        __mfeName__: "tpdTelepedaggioAreaRiservataWidget",
        devClientPort: 6302,
        devServerPort: 6402,
    },
});
exports.WIDGET_TELEPEDAGGIO_REMOTES_SETTINGS = settings;
